"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getLessonContentByEnv_1 = require("./getLessonContentByEnv");
var getWalkthroughsById_1 = __importDefault(require("./getWalkthroughsById"));
var mocks = {
    Query: function () { return ({
        getWalkthroughsById: function () { return getWalkthroughsById_1.default; },
        getLessonContentByEnv: function () { return getLessonContentByEnv_1.getLessonContentByEnvMock; },
    }); },
};
exports.default = mocks;
